import './oauthHandoff';
import { shouldDeferReactBootstrapForNativeOAuthHandoff } from './lib/capacitorZitadelUrls';

/**
 * Do not statically import `./App` here. On the IdP HTTPS redirect document,
 * that would still evaluate `App.tsx` and construct `UserManager` before the
 * `if` runs — wrong localStorage partition for PKCE/state.
 */
if (!shouldDeferReactBootstrapForNativeOAuthHandoff()) {
  void import('./bootstrapApp');
}
